import DatricRequests from '../datric.requests';
import {
	LeilaoConfig,
	LeilaoFilters,
	LeilaoPage,
	LeilaoPurchase,
	LeilaoPurchaseResult
} from '../../../models/leilao.model';

const requests = new DatricRequests();

export async function listLeilaoLeads(filters: LeilaoFilters): Promise<LeilaoPage> {
	return requests.get('leilao/leads', filters);
}

export async function purchaseLeilaoLeads(ids: string[]): Promise<LeilaoPurchaseResult> {
	return requests.post('leilao/purchase', { ids });
}

export async function listLeilaoPurchases(params: {
	page?: number;
	limit?: number;
}): Promise<{ data: LeilaoPurchase[]; meta: LeilaoPage['meta'] }> {
	return requests.get('leilao/purchases', params);
}

// O XLSX é montado por streaming no servidor; aqui só recebemos o arquivo pronto.
export async function exportLeilaoPurchases(): Promise<Blob> {
	return requests.get('leilao/purchases/export', undefined, { responseType: 'blob' });
}

export async function getLeilaoConfig(): Promise<LeilaoConfig> {
	return requests.get('leilao/config');
}

export async function updateLeilaoConfig(payload: Partial<LeilaoConfig>): Promise<LeilaoConfig> {
	return requests.put('leilao/config', payload);
}
